(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["first-win-home"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-fw]').forEach(function(root){
    var rot = root.querySelector('[data-fw-rot]');
    var names = ["Your Starbucks order","Your Dunkin' run","Your kitchen pot","Your office coffee"];
    var i = 0;
    if (rot && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setInterval(function(){
        rot.style.opacity = 0;
        setTimeout(function(){ i = (i + 1) % names.length; rot.textContent = names[i]; rot.style.opacity = 1; }, 250);
      }, 2600);
    }

    var onePrice = root.dataset.onePrice;
    var planPrice = root.dataset.planPrice;
    var planName = root.dataset.planName;
    var planLabel = root.dataset.planLabel || 'Subscribe';
    var form = root.querySelector('[data-fw-quiz]');
    var box = root.querySelector('[data-fw-result]');
    var wallLine = {morning:"Your day runs out early.",afternoon:"Your wall is the 2pm wall.",evening:"You run out right when they need you.",focus:"You want a sharper morning."};
    var timing = {morning:"Scoop into your very first cup.",afternoon:"Scoop into your morning cup — the one before work.",evening:"Scoop into your midday cup so it carries you to pickup.",focus:"Scoop into the cup you drink before your hardest work."};
    var srcLine = {home:"Stir it into your kitchen brew.",shop:"Stir it into your shop order — keep a scoop in your bag.",office:"Keep the bag at your desk next to the pot."};
    if (form && box) {
      form.addEventListener('change', function(){
        var d = Object.fromEntries(new FormData(form));
        if (!d.wall || !d.cups || !d.src) return;
        box.classList.remove('fw-result--empty');
        box.querySelector('[data-fw-r-title]').textContent = wallLine[d.wall];
        box.querySelector('[data-fw-r-body]').textContent = timing[d.wall] + ' ' + srcLine[d.src] + ' One scoop a day, not one per cup.';
        var sub = d.cups !== '1' && planPrice;
        box.querySelector('[data-fw-r-plan]').textContent = sub ? (planLabel + ' · ' + planName) : 'One bag · 15 mornings';
        box.querySelector('[data-fw-r-price]').textContent = sub ? planPrice : onePrice;
        box.querySelector('[data-fw-r-cta]').textContent = sub ? planLabel : 'Try one bag';
        var pick = root.querySelector(sub ? '#fw-p-sub' : '#fw-p-one');
        if (pick) { pick.checked = true; pick.dispatchEvent(new Event('change', {bubbles: true})); }
      });
    }

    var buy = root.querySelector('[data-fw-buy]');
    var planInput = root.querySelector('[data-fw-plan-input]');
    if (buy && planInput) {
      buy.addEventListener('change', function(e){
        if (e.target.name !== 'fw_purchase') return;
        planInput.disabled = e.target.value !== 'sub';
        var add = buy.querySelector('[data-fw-add]');
        if (add && !add.disabled) add.textContent = e.target.value === 'sub' ? planLabel : 'Add to bag';
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
